import {
    STOCK_TAKING_CAR_MANAGEMENT_BRANDS_DATA_MASTER_BEGIN,
  } from '../constants';
  
  export function getBrandsDataMaster() {
    return (dispatch) => {
      dispatch({
        type: STOCK_TAKING_CAR_MANAGEMENT_BRANDS_DATA_MASTER_BEGIN,
      })
    }
  }